const customFetch = async (url, options) => {
  try {
    const response = await fetch(url, options);
    if (response.status === 401) {
      window.location.href = '/login';
      return;
    }

    if (response.status === 403) {
      window.location.href = '/login';
      return;
    }

    if (!response.ok) {
      let errorMessage = response.statusText;
      try {
        const errorData = await response.json();
        errorMessage = errorData.message || errorMessage;
      } catch {}
      throw new Error(errorMessage);
    }
    return response;
  } catch (error) {
    console.error('Fetch Error:', error.message);
    throw error;
  }
};

export default customFetch;
